document.addEventListener("DOMContentLoaded", function () {
    // Select all variant radios on the page
    document.querySelectorAll("variant-radios-card").forEach(function (variantRadios) {
      // For each label inside
      variantRadios.querySelectorAll(".label-color").forEach(function (label) {
        label.addEventListener("click", function (e) {
          e.preventDefault();
          const selectedColor = label.getAttribute("data-color");
          const card = label.closest(".card");

          if (!card) return;

          // Hide default images when a color swatch is clicked
          const defaultImages = card.querySelectorAll(".card__img-inner--default");
          defaultImages.forEach(function(defaultImage) {
            defaultImage.classList.add("card__img-inner--hidden");
          });

          // Add visible class to card__img-inner elements
          const cardImgInnerElements = card.querySelectorAll(".card__img-inner");
          cardImgInnerElements.forEach(function(imgInner) {
            imgInner.classList.add("card__img-inner--visible");
          });

          const imageContainers = card.querySelectorAll(".card__img-inner > div");

          imageContainers.forEach(function (container) {
            container.classList.add("hidden");

            // Match the data-option with selectedColor
            if (container.getAttribute("data-option") === selectedColor) {
              container.classList.remove("hidden");
            }
          });
        });
      });
    });
  });